import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import rootReducer from "./reducers";
import { getPersistConfigKey } from "./utils";

const persistConfig = {
  key: getPersistConfigKey(
    process.env.NODE_ENV === "development" ? true : false,
  ),
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export { persistedReducer, persistStore };
